import { createUseStyles } from 'react-jss';

const styles = {
  classTypeTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '3rem',
  },
  classTypeText: {
    marginLeft: '1rem',
    fontSize: '1.8rem',
    fontWeight: '700',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
